import { useEffect, useState } from "react";
import "./organizationEmployee.css";
import PaginationComponent from "../../components/PaginationComponent";
import ListItem from "./Components/ListItem";
import withRoleBased from "../../utils/Functions/withRoleBased";
import useOrganizationEmployeeList from "../../utils/CustomHooks/useOrganizationEmployeeList";
import { sortArray } from "../../utils/Functions/filter";
import OrganizationEmployeeModal from "./modal/OrganizationEmployeeModal";

function OrganizationEmployee({ access = {} }) {
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize] = useState(10);
  const [count, setCount] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const { organizationEmployeeList, loading, getOrganizationEmployeeList } =
    useOrganizationEmployeeList("");
  const { canCreate } = access;
  const [search, setSearch] = useState("");
  const [isSearching, setIsSearch] = useState(false);

  useEffect(() => {
    let req = {};
    if (search) req.organization_employee_name = search;
    getOrganizationEmployeeList(req);
  }, [count]);

  const handleClick = (event, index) => {
    event.preventDefault();
    setCurrentPage(index);
    // console.log(`Viewing Page ${index + 1} Data`);
  };
  const pageCount = Math.ceil(organizationEmployeeList.length / pageSize);

  const onSearch = () => {
    setCurrentPage(0)
    setCount((x) => x + 1);
    setIsSearch(search ? true : false);
  };
  return (
    <main className="page-content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-6 mb-3">
            <h5 className="page-title">Organization Employee</h5>
          </div>
          <div className="col-md-6  mb-3 d-flex justify-content-end">
            {canCreate && (
              <button
                type="button"
                className="btn btn-outline-success "
                onClick={() => setIsOpen(true)}
              >
                Add Organization Employee
              </button>
            )}
          </div>
          <div className="col-md-4">
            <div className="search" style={{ margin: "16px 0px 32px" }}>
              <input
                type="text"
                className="form-control"
                placeholder="Search"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && onSearch()}
              />
              {!isSearching ? (
                <button onClick={onSearch}>
                  <i className="fa fa-search" />
                </button>
              ) : (
                <button
                  onClick={() => {
                    setSearch("");
                    setIsSearch(false);
                    setCount((x) => x + 1);
                  }}
                >
                  <i className="fa fa-times" />
                </button>
              )}
            </div>
          </div>
          <div className="col-md-12">
            <div className="table-responsive">
              <table className="table domain-table table-borderless">
                <thead>
                  <tr className="">
                    <td className="">Name</td>
                    <td className="">Email</td>
                    <td className="">Status</td>
                    {access.canEdit && <td className="">Action</td>}
                  </tr>
                </thead>
                <tbody>
                  {!loading &&
                  organizationEmployeeList &&
                  organizationEmployeeList.length > 0 ? (
                    sortArray(organizationEmployeeList)
                      .slice(
                        currentPage * pageSize,
                        (currentPage + 1) * pageSize
                      )
                      .map((item, i) => (
                        <ListItem
                          item={item}
                          i={i}
                          key={i}
                          refresh={() => {
                            setCount((x) => x + 1);
                          }}
                          access={access}
                        />
                      ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center">
                        <span className="font-weight-bold">
                          {loading ? "Loading..." : "Oops! No Data Found"}
                        </span>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {organizationEmployeeList.length > 0 && pageCount != 1 && (
          <PaginationComponent
            handleClick={handleClick}
            currentPage={currentPage}
            pageCount={pageCount}
          />
        )}
        <OrganizationEmployeeModal
          isOpen={isOpen}
          setOpen={setIsOpen}
          refresh={() => {
            setCount((x) => x + 1);
          }}
          isEditable={access.canEdit}
        />
      </div>
    </main>
  );
}

export default withRoleBased(OrganizationEmployee, "subDomain");
